import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  connect() {
    this.center = document.querySelector("[data-resume-resize-center]")
    this.onMove = this.onMove.bind(this); this.onUp = this.onUp.bind(this)
    this.element.addEventListener("pointerdown", (e) => { e.preventDefault(); this.startX = e.clientX; this.startW = this.center ? this.center.offsetWidth : 430; document.addEventListener("pointermove", this.onMove); document.addEventListener("pointerup", this.onUp) })
    try { const w = localStorage.getItem("rb-center-w"); if (w && this.center) this.center.style.width = w + "px" } catch (_e) {}
  }
  onMove(e) {
    if (!this.center) return
    let w = this.startW + (e.clientX - this.startX)
    w = Math.max(340, Math.min(620, w))
    this.center.style.width = w + "px"; this.center.style.flex = "0 0 auto"
  }
  onUp() {
    document.removeEventListener("pointermove", this.onMove); document.removeEventListener("pointerup", this.onUp)
    try { if (this.center) localStorage.setItem("rb-center-w", this.center.offsetWidth) } catch (_e) {}
  }
}
